import Modal from "react-bootstrap/Modal";
import React, { Component,  useEffect, useState } from "react";
import Button from "react-bootstrap/Button";
import ReactSpinner from "react-bootstrap/Spinner";
import { Box, Chip, IconButton, styled } from "@mui/material";
import Paper from "@mui/material/Paper";
import { namespace, cgcDocSubmisBlobName } from "../../../../../helper/namespace.js";
import { NonAcademicService } from "../../../../../service/manage/registration/reg_b_staff.service.js";
import { customerConstants } from "../../../../../helper/constants.js";
import { AzureStorageManage } from "../../../../../helper/azureStorageManage.js";
import { sweetStatusAlert } from "../../../../../components/common/SweetAlert.js";
import config from "../../../../../helper/config.js";
import DownloadIcon from '@mui/icons-material/Download';
import VisibilityIcon from '@mui/icons-material/Visibility';
import LinearProgress from '@mui/material/LinearProgress';
import { DeleteForever } from "@material-ui/icons";
import { regBStaffDocUploadTypes } from "../../../../../helper/namespace.js";

const RegBStaffDocUpdateModal = ({regBDocUpdateModel, toggleRegBDocUpdateModel, selectedStudent, closeBtnStyle, state, fetchAllStudents, visibility}) => {

    const truncateFileName = (fileName, maxLength = 25) => {
        if (fileName?.length > maxLength) {
        return "..." + fileName.substring(fileName.length - maxLength);
        }
        return fileName;
    };
    const getCustomerFeatureFlag = () => {
        return config.customerConfigs.featureFlag
    }
    let cancelClass, confirmClass;
    const customer = getCustomerFeatureFlag();
    switch (customer) {
        case customerConstants.EXO_CUSTOMER1:
            cancelClass = "btn-default";
            confirmClass = "btn-primary";
            break;
        case customerConstants.EXO_CUSTOMER2:
        // cancelClass = "cmc-btn-default"
        // confirmClass = "cmc-btn-primary"
        default:
            cancelClass = "btn-default";
            confirmClass = "btn-primary";
            break;
    }
    
    const Item = styled(Paper)(({ theme }) => ({
        ...theme.typography.body2,
        textAlign: "center",
        color: theme.palette.text.secondary,
        lineHeight: "40px",
        padding: theme.spacing(2), // Add padding
        marginBottom: theme.spacing(1),
        marginRight: theme.spacing(3),
    }));
    const initialStateUploadFiles = {}
    const initialStateSelectedFiles = {
        selectedFilePhoto:[],
        selectedFileCertificates:[],
        selectedFileNIC:[],
        selectedFilePoliceReports:[],
        selectedFileOther:[],
    }

    const [uploadedFiles, setUploadedFiles] = useState({...initialStateUploadFiles})
    const [selectedFiles, setSelectedFiles] = useState({...initialStateSelectedFiles})
    const [containerId, setContainerId] = useState(null)
    const [loading, setLoading] = useState(false)


    // Helper function to read file as text
    const readFile = (file) => {
        return new Promise((resolve, reject) => {
          const reader = new FileReader();
    
          reader.onload = (event) => {
            resolve(event.target.result);
          };
    
          reader.onerror = (error) => {
            reject(error);
          };
    
          reader.readAsArrayBuffer(file);
        });
      }; 

    const nameCheckForFileUpload = (file, typeName) => {
        const isHaveSameName = selectedFiles[typeName].some(file_ => file[0].name === file_[0].name)
        if(isHaveSameName){
            sweetStatusAlert(namespace.FAILED, `File names are similar`, "error")
            return true
        }
        return false
    }

    const sizeCheckForFileUpload = (file) => {
        if(file[0].size > config.fileUploadConfigs.maxFileSize){
            const maxFileSizeInGB = (config.fileUploadConfigs.maxFileSize / (1024 * 1024));
            sweetStatusAlert(namespace.FAILED, `The maximum file size of ${maxFileSizeInGB}GB has been exceeded. Check the size of the file ${file[0].name}!`, "error")
            return true
        }
        return false
    }


    const handleSelectedFiles = (e, type_id) => {
        const{name ,files} = e.target
        if(sizeCheckForFileUpload(files)){
            return
        }
        if(nameCheckForFileUpload(files, name)){
            return
        }
        setSelectedFiles({...selectedFiles, [name]:[...selectedFiles[name],files]})
    }

    const processUploads = async (selectedStudent) => {
        try {
            setLoading(true)
            const res = await NonAcademicService.getRegUploadsByStaffMember(selectedStudent.user_id, selectedStudent.user_table_id)
            const photoBlobs = []
            if (res?.success) {
                res.data.forEach((blobDetail) => {
                    
                    if (blobDetail.upload_type_id === regBStaffDocUploadTypes.REG_B_STAFF_UPLOADS.id) {
                        photoBlobs.push(blobDetail);
                    }
                });
                const initialFetchedFiles = {
                    ...photoBlobs,
                }
                setUploadedFiles(initialFetchedFiles)

                const containerId = res.data[0]?.container_id ? res.data[0]?.container_id : `${customer}_form${state.form_list}`
                .toLowerCase()
                .replace(/[^a-z0-9-]/g, "-")
                .replace(/^-+|-+$/g, "");
                setContainerId(containerId)
            }
        } catch (error) {
        sweetStatusAlert(namespace.FAILED, `Unable to retreive documents!!!`, "error")
        } finally{
            setLoading(false)
        }
        
    }

    useEffect(() => {
        if(!regBDocUpdateModel){
            setUploadedFiles({...initialStateUploadFiles})
        }else{
            processUploads(selectedStudent)
        }
    },[regBDocUpdateModel])

    const handleBlobsDetail = async(labelName, selectedFileType, user_code, std_id) => {
        const form_list = state?.form_list_id;
        let blobIds = []
        if(!!selectedFiles[selectedFileType].length){
          const typeBlobDetails = await Promise.all(selectedFiles[selectedFileType].map(async(file, index) => {
            const name_ = file[0].name
            const blobId = cgcDocSubmisBlobName(name_, form_list, labelName, index ,user_code,std_id)
            const readData = await readFile(file[0])
            blobIds.push(blobId)
            return {
              blobData:readData,
              blobName:blobId
            }
          }))
          return {
            typeBlobDetails:typeBlobDetails,
            typeIds:blobIds
          }
        }else{
          return {
            typeBlobDetails:[],
            typeIds:blobIds
          }
        }
      }

    const handleDocDelete = async (container_id, blobName) => {
        if(!visibility.delete)return
        try {
            setLoading(true)
            await AzureStorageManage.deleteblob(container_id, blobName)    
            await NonAcademicService.deleteRegUpload(container_id,blobName)        
        } catch (error) {
        } finally{
            await processUploads(selectedStudent)
            setLoading(false)
            sweetStatusAlert(namespace.SUCCESS, `File deleted successfully!!!`, "success")
        }
    }
    
    const handleSelectedFileDownload = async (container_id, blobName) => {
        try {
            await AzureStorageManage.downloadBlob(container_id, blobName)
        } catch (error) {
            sweetStatusAlert(namespace.SUCCESS, `File downloaded successfully!!!`, "success")            
        }
    }

    

    const handleOpenFile = async (container_id, blobName) => {
        await AzureStorageManage.setInline(container_id, blobName)
        const blobUrl = await AzureStorageManage.generateSASUrl(container_id, blobName)
        window.open(blobUrl, '_blank')
    }

    const clearSpecificInput = (selectedFileType) => {
        setSelectedFiles({...selectedFiles, [selectedFileType]:[]})
    }

    const handleDocUpload = async(type, selectedFileType, type_id) => {
        const {lg_user_id, lg_user_table_id} = state

        try {
            setLoading(true)
            const blobsDetail = await handleBlobsDetail(type, selectedFileType, selectedStudent.user_code, selectedStudent.std_id)
            await AzureStorageManage.multiUploadBlob(containerId, blobsDetail.typeBlobDetails)
          
          const obj = {
            user_id: selectedStudent.user_id,
            user_table_id: selectedStudent.user_table_id,
            create_user_id: lg_user_id,
            create_user_table_id: lg_user_table_id,
            container_id: containerId,
            blob_details:[
              {
                upload_type_id:type_id,
                blob_ids:blobsDetail?.typeIds, 
              },
            ]
          }
          await NonAcademicService.addRegUploads(JSON.stringify(obj));
          clearSpecificInput(selectedFileType)
          sweetStatusAlert(namespace.SUCCESS, `File uploaded successfully!!!`, "success")
        } catch (e) {
        } finally {
            setLoading(false)
            await processUploads(selectedStudent)
        }
    }

    const concatText = (selectedFileType) => {
        let concatText =''
        selectedFiles[selectedFileType].forEach((file, index) =>{
            if(index !== 0){
                concatText = concatText +', ' + file[0].name
            }else{
                concatText = concatText + file[0].name
            }
        })
        return concatText
    }

    const uploadComponent = (label, selectedFileType, uploadedFileType, type) => {
        
        return (
            <Item elevation={0} sx={{ pl: 5, pr: 5 }}>
            <div className="row">
                <div className="col-3">
                    <div>{label} : </div>
                </div>
                <div className="col-9">                    
                    <div className="d-flex">
                        {(!loading && !!selectedFiles[selectedFileType]?.length )&& <DeleteForever
                            sx={{ fontSize: 60 }}
                            style={{ cursor: "pointer" }}
                            onClick={() => {clearSpecificInput(selectedFileType)}}
                        />}
                        <div>
                          <div className="card">
                            <div className="file-upload-section">
                              <label
                                htmlFor="fileInput"
                                className="custom-file-label"
                              >
                                {selectedFiles[selectedFileType]?.length
                                    ? `${truncateFileName(selectedFiles[selectedFileType][0][0]?.name)}  ${!!(selectedFiles[selectedFileType].length- 1) ? (' + ' + (selectedFiles[selectedFileType].length - 1)): ""}`
                                    : "Select a file"
                                }
                              </label>

                              <input
                                    title={concatText(selectedFileType)}
                                    type="file"
                                    name={selectedFileType}
                                    onChange={(e)=>handleSelectedFiles(e, type.id)}
                                    className="custom-file-input"
                                    style={{ width: "100%" ,cursor:'pointer' }}
                                />
                            </div>
                          </div>
                        </div>
                        <div className="px-2">
                        {(!!selectedFiles[selectedFileType]?.length && visibility.edit && !loading && <div>
                                <Button
                                    className="insert-btn"
                                    variant="primary"
                                    onClick={() => handleDocUpload(label.toLowerCase(),selectedFileType, type.id)}
                                    >
                                    Upload
                                </Button>
                            </div>)}
                        </div>
                      </div>
                    {loading &&  <div><LinearProgress/></div>}
                </div>
                
                <div>
                    {!loading  && (
                        <div style={{ display: 'flex', flexWrap: 'wrap', gap: '10px' }}>
                            {uploadedFiles &&
                                Object.values(uploadedFiles).map((file, index) => {
                                    return (
                                        <div key={index} style={{ display: 'flex', alignItems: 'center', gap: '2px', marginBottom: '10px' }}>
                                            <Chip
                                                icon={<DownloadIcon />}
                                                label={truncateFileName(file?.blob_id, 14)}
                                                variant="outlined"
                                                onClick={()=>{handleSelectedFileDownload(file.container_id, file.blob_id)}}
                                                onDelete={()=>{handleDocDelete(file.container_id, file.blob_id)}}
                                            />
                                            <IconButton onClick={()=>{handleOpenFile(file.container_id, file.blob_id)}}>
                                                <VisibilityIcon />
                                            </IconButton>
                                        </div>
                                    )
                                })
                            }
                        </div>
                        )
                    }
                </div>
            </div>
        </Item>
        )
    }


    return (
        <div>
            <Modal
                size="lg"
                aria-labelledby="contained-modal-title-vcenter"
                centered
                show={regBDocUpdateModel}
                onHide={() => toggleRegBDocUpdateModel(null)}
            >
                <Modal.Header closeButton>
                    <Modal.Title>
                    {" "}
                        <h3>
                            {selectedStudent?.first_name +
                            " " +
                            selectedStudent?.last_name}
                        </h3>
                    {" "}
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div>
                        {false ?
                            <ReactSpinner
                                animation="border"
                                role="status"
                                style={{ display: "block", margin: "auto" }}
                            >
                                <span className="sr-only">Loading...</span>
                            </ReactSpinner> : (
                                <div className="col-md-12">
                                    <>        
                                    {uploadComponent('Staff Documents', 'selectedFileCertificates','uploadedFileCertificates', regBStaffDocUploadTypes.REG_B_STAFF_UPLOADS)}
                                    </>
                                </div>
                            )}
                    </div>
                    
                </Modal.Body>
                <Modal.Footer>
                    <Button
                        id="modal-close-button"
                        style={closeBtnStyle}
                        onClick={() =>
                            toggleRegBDocUpdateModel(null)
                        }
                    >
                        Close
                    </Button>
                </Modal.Footer>
            </Modal>
        </div>
    )
}

export default RegBStaffDocUpdateModal
